/**
 * Placeholder visible al estudiante cuando falta imageUrl.
 * Nunca exponer imagePrompt técnico (suele estar en inglés).
 */

const TECHNICAL_PROMPT_RE =
  /\b(illustration|historical|colorful|educational|flat\s+illustration|scene|prompt|students?|odysseus|wiki)\b/i;

/**
 * @param {{ altText?: string; caption?: string; title?: string; imagePrompt?: string }} payload
 * @returns {string}
 */
export function resolveFiguraStudentPlaceholder(payload = {}) {
  const altText = String(payload.altText || '').trim();
  const caption = String(payload.caption || '').trim();
  const title = String(payload.title || '').trim();
  const imagePrompt = String(payload.imagePrompt || '').trim();
  const altIsPromptEcho =
    Boolean(altText) && Boolean(imagePrompt) && altText.toLowerCase() === imagePrompt.toLowerCase();
  const looksTechnical = TECHNICAL_PROMPT_RE.test(altText) || altIsPromptEcho;

  if (altText && !looksTechnical) return altText;
  if (caption) return caption;
  if (title) return title;
  return 'Ilustración no disponible. El docente puede actualizarla en el editor.';
}
